import React, { useEffect, useState } from 'react';
import Form from './Form';
import useScan from '../../hooks/useScan';
import { getPropertyByNid } from 'src/redux/properties/apis';
import { updateProperty } from '../../redux/properties/thunks';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Loading from '../common/Loading';

const EditProperty = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { setDestination } = useScan();
  const { id: nid } = useParams();

  const [propertyEdit, setPropertyEdit] = useState({
    data: { nid: null, url: '', address: '', observations: '' },
    isLoading: true,
    error: false,
  });

  const { properties } = useSelector(
    (state: any) => state.properties.properties
  );
  const submitEditProperty = (values: any) => {
    dispatch(updateProperty({ values }))
      .unwrap()
      .then((res: any) => {
        if (res) {
          navigate('/properties', { replace: true });
        }
      });
  };

  const getPropertyToEdit = async () => {
    const { data } = await getPropertyByNid({
      nid: nid as string,
    });
    const property = data.properties[0];
    setPropertyEdit({ isLoading: false, error: false, data: property });
  };

  useEffect(() => {
    setDestination('act-e-pro', false);
  }, []);

  useEffect(() => {
    if (!nid) {
      return;
    }

    if (!properties.length) {
      getPropertyToEdit();
    } else {
      setPropertyEdit({
        isLoading: false,
        error: false,
        data: properties.find((item: any) => item.nid === parseInt(nid, 10)),
      });
    }
  }, [nid]);

  if (propertyEdit.isLoading) {
    return (
      <div className='flex items-center justify-center flex-col'>
        <Loading />
      </div>
    );
  }
  return (
    <Form
      submitProperty={submitEditProperty}
      initialValues={propertyEdit.data}
      actionText='GUARDAR'
      type='edicion'
    />
  );
};

export default EditProperty;
